module.exports = __webpack_public_path__ + "static/media/store-alt-solid.505c19fa.svg";